



































































































import {Component, Vue} from 'vue-property-decorator';
import {ObjectFactory} from '../../config/objectFactory';
import {ApiRequest} from '../../types/request';
import {MedTransGoConstants} from '../../util/constants';
import {validationMixin} from 'vuelidate';
import {alphaNum, email, minLength, required} from 'vuelidate/lib/validators';
import {MapUtils} from '../../util/mapUtils';
import {ToastEvent} from '../../types/event';
import {CommonUtils} from '../../util/commonUtils';
import {EventBus} from '../../main';
import {OrgLocation, Patient} from '../../types/entity';
import {MemberProfile} from '../../types/response';
import {ResourceUtils} from '../../util/resourceUtils';

declare var google: any;
@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            birthdate: '',
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
            location: '',
            imagePreview: '',
            imageFile: '',
            caseNumber: '',
            member: ObjectFactory.getCacheService().getMemberInfo(),
        };
    },
    validations() {
        const validations = {
            fullName: {
                required,
                regex: (fullName: any) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: any) =>
                    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone),
            },
            address: {
                fullAddress: {
                    required,
                },
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
            location: {
                required,
            },
        };
        if (this.$data.member.memberType !== 'ORG_LIEN_CUSTOMER') {
            delete validations.email;
        }
        return validations;
    },
    methods: {
        setPreviewImage(e) {
            const files = e.target.files;
            if (files.length === 0) {
                return;
            }
            this.$data.imageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                if (event.target) {
                    this.$data.imagePreview = event.target.result;
                }
            },
            reader.readAsDataURL(files[0]);
        },
    },
})
export default class UpdatePatientModal extends Vue {
    private patientGoogleAddress: any;
    private show = false;
    private locations: OrgLocation[] | undefined = [];
    private maxDate = new Date();


    public mounted() {
        this.getGoogleAddress();
        this.getOrganizationLocations();
        this.getPatientDetails(this.$route.params.id);
        this.maxDate.setFullYear(this.maxDate.getFullYear());
    }

    private async getPatientDetails(patientId: any) {
        const response = await ObjectFactory.getPatientService().getPatientDetails(this.$store.state.serverUrl,
        patientId);
        if (response.success && response.data) {
            this.$data.fullName = response.data.fullName;
            this.$data.email = response.data.email;
            this.$data.phone = response.data.phone;
            this.$data.caseNumber = response.data.caseNumber;
            if (response.data.address) {
                this.$data.address = response.data.address;
            }
            this.$data.birthdate = response.data.birthdate;
            this.$data.location = response.data.location;
            this.show = true;
            if (response.data.profilePhoto) {
                this.getPatientProfileImage(response.data.profilePhoto);
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async updatePatient() {
        const iHttpService = ObjectFactory.getHttpService();
        const patientUpdateRequest: Patient = {
            fullName: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            address: this.$data.address,
            birthdate: this.$data.birthdate,
            location: this.$data.location,
            caseNumber: this.$data.caseNumber, // Include caseNumber in update
        };
        if (this.$data.imageFile) {
            patientUpdateRequest.profilePhoto = await this.uploadProfileImage();
        }
        const response = await ObjectFactory.getPatientService().updatePatient(this.$store.state.serverUrl,
        this.$route.params.id, patientUpdateRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_PATIENT'),
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.patientGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('patientAddress'), {
                    types: ['geocode'],
                },
            );
            this.patientGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.patientGoogleAddress,
                );
            });
        });
    }

    private async getOrganizationLocations() {
        if (!this.locations || this.locations.length <= 0) {
            const memberProfile = ObjectFactory.getCacheService().getValue(
                MedTransGoConstants.FIELD_MEMBER_PROFILE,
            ) as MemberProfile;
            if (memberProfile.organization) {
                const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
                if (response.success && response.data) {
                    response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
                    this.locations = response.data;
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }

    private async uploadProfileImage(): Promise<string> {
        const iHttpService = ObjectFactory.getHttpService();
        const formData = new FormData();
        formData.append('file', this.$data.imageFile);
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: formData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post(apiRequest);
        if (response.success && response.data) {
            return response.data.fileName;
        } else {
            CommonUtils.showError(response);
            throw new Error('Faled to upload image');
        }
    }

    private async getPatientProfileImage(resourceId: string) {
        this.$data.imagePreview = require('../../assets/images/loader_download.gif');
        this.$data.imagePreview = await ResourceUtils.getResourceUrl(this.$store.state.serverUrl, resourceId);
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
        replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }


    private close() {
        this.$router.back();
    }
}
